import { ChangeDetectionStrategy, Component, inject, Input, output } from '@angular/core';
import { MngActionDef } from '../mng-actiondef';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { MatMenuItem } from '@angular/material/menu';
import { LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';
import { MngIconComponent } from '@mng/mng-icon';
import { MatDivider } from '@angular/material/divider';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'mng-menu-button',
  imports: [MatMenuItem, LayoutDirective, LayoutAlignDirective, MngIconComponent, MatDivider, MatTooltip],
  template: `
    @if (actionDef.isVisible(actionArg)) {
      <div matTooltipShowDelay="50" [matTooltip]="isDisabled ? getDisabledTooltipMessage() : null">
        <button
          mat-menu-item
          fxLayout="row"
          fxLayoutAlign="start center"
          [attr.id]="actionDef.id"
          [disabled]="isDisabled"
          (click)="executeMenuAction.emit(actionDef)"
        >
          @if (actionDef.iconTemplate) {
            <span style="pointer-events: none;" ngProjectAs="mat-icon" [innerHTML]="actionDef.iconTemplate"></span>
          }
          @if (actionDef.getIconName()) {
            <mng-icon
              style="pointer-events: none;"
              ngProjectAs="mat-icon"
              [color]="actionDef.getIconColor()"
              [iconName]="actionDef.getIconName()"
            />
          }
          <span fxLayout="row" style="pointer-events: none;"
            ><span style="pointer-events: none;" [innerHTML]="sanitizeHtml(actionDef.getText())"></span>&nbsp;
            @if (actionDef.externalUrlTarget === '_blank') {
              <mng-icon style="margin-left: 4px; pointer-events: none" iconName="open-in-new" [fontSize]="16" />
            }
          </span>
        </button>
      </div>
    }
    @if (actionDef.divider) {
      <mat-divider />
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MngMenuButtonComponent {
  @Input() actionDef: MngActionDef;
  @Input() actionArg: any;

  readonly executeMenuAction = output<MngActionDef>();

  private readonly sanitizer = inject(DomSanitizer);

  sanitizeHtml(html: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  get isDisabled(): boolean {
    const arg = this.actionArg;
    return arg !== undefined ? this.actionDef.isDisabled(arg) : this.actionDef.isDisabled();
  }

  getDisabledTooltipMessage() {
    if (!this.actionDef.disabledTooltip) {
      return;
    }

    const arg = this.actionDef.actionArg;
    return arg !== undefined ? this.actionDef.disabledTooltip(arg) : this.actionDef.disabledTooltip();
  }
}
